import React from 'react';
import { LeadFormData } from '../leadFormUtils';

export interface LeadNotesSectionProps {
  formData: LeadFormData;
  onFieldChange: <K extends keyof LeadFormData>(field: K, value: LeadFormData[K]) => void;
}

export const LeadNotesSection: React.FC<LeadNotesSectionProps> = ({
  formData,
  onFieldChange,
}) => (
  <section className="lead-form-shared__section">
    <h3 className="lead-form-shared__section-title">Notes</h3>

    <div className="lead-form-modal__field lead-form-shared__field--full">
      <label className="lead-form-modal__label" htmlFor="lead-notes">
        Notes / Description
      </label>
      <textarea
        id="lead-notes"
        className="lead-form-modal__textarea"
        placeholder="Add any relevant background information here..."
        rows={4}
        value={formData.notes}
        onChange={(e) => onFieldChange('notes', e.target.value)}
      />
    </div>
  </section>
);
